import React, { memo } from 'react';
import { View } from 'react-native';
import { createUseStyle } from '@redlink/assets/styles';
import {
  Text,
  Card,
  UserAvatar,
  Divider,
  Space,
} from '@redlink/components/atoms';
import { DrawerIcon, Button } from '@redlink/components/molecules';
import { useValues } from '@redlink/assets/values';
import { useLocale } from '@redlink/assets/locale';

export const PageItem = memo(
  ({
    item: { fullname, avatar, pageName, visibleTabs = [] },
    onSelect,
    archive = false,
    style,
  }) => {
    const { styles, colors } = useStyle();
    const { getPageLink, staticData } = useValues();
    const { dictionary } = useLocale();
    return (
      <Card style={[styles.container, style]}>
        <View style={archive && styles.disbaleContainer}>
          <View style={styles.headerContainer}>
            <UserAvatar
              source={{ uri: avatar?.thumbnailUrl }}
              style={styles.avatar}
            />
            <Space size={8} />
            <Text style={styles.fullnameText}>{fullname}</Text>
            <Space size={8} />
            <Text style={styles.urlText} en>
              {getPageLink(pageName)}
            </Text>
          </View>
          <Space />
          <View style={styles.tabItemsContainer}>
            {staticData.previewTabs.map((item) => {
              const isActive = !!visibleTabs.find((i) => i === item);
              return (
                <>
                  <DrawerIcon
                    name={item}
                    color={isActive ? colors.gray23 : colors.gray22}
                    size={16}
                  />
                  <Space size={8} />
                </>
              );
            })}
          </View>
          <Divider margin={7} />
        </View>
        {!archive && (
          <Button
            title={dictionary.enterPage}
            variant="secondarySimple"
            onPress={onSelect}
          />
        )}
        {archive && (
          <Button
            title={dictionary.renewPage}
            variant="secondarySimple"
            onPress={onSelect}
          />
        )}
      </Card>
    );
  }
);

const useStyle = createUseStyle(({ colors, shadow, size }) => ({
  container: {
    justifyContent: 'center',
    minWidth: 200,
    paddingBottom: 5,
    height: 225,
    marginEnd: 16,
    marginBottom: 16,
  },
  disbaleContainer: {
    opacity: 0.3,
  },
  headerContainer: {
    alignItems: 'center',
  },
  avatar: {
    width: 48,
    height: 48,
  },
  tabItemsContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
  },
  fullnameText: {
    fontSize: 14,
    color: colors.gray21,
  },
  urlText: {
    fontSize: 20,
    color: colors.gray23,
  },
}));
